import { useState } from 'react'
import { LoginImport } from './Imports'
const { UserLoginForm, ForgetPasswordForm, Card, Swiper, SwiperSlide, Autoplay, EffectCoverflow, Pagination, FaStar, LuCopyright, dashboard_img, planning_img, sales_order_img, delivery_planning_img, customer_details_img, AOS } = LoginImport

export default function UserLogin() {

    const [toggle, setTogggle] = useState(false)
    AOS.init();

    return (
        <>
            <div className='row side_bg g-0'>
                <div className="col-sm-12 col-lg-7 my-auto">
                    <div>
                        <div className='text-white p-4'>
                            <img src="./rexo-flow.png" alt="fav" className='img-fluid side_fav_img' />
                            <h6 className='mt-2 text-light'>Welcome to Rexo Flow</h6>
                        </div>

                        <div className='pt-3 pb-3'>
                            <Swiper
                                effect={'coverflow'}
                                loop={true}
                                grabCursor={true}
                                centeredSlides={true}
                                slidesPerView={2}
                                coverflowEffect={{
                                    rotate: 50,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 1,
                                    slideShadows: true,
                                }}
                                autoplay={{
                                    delay: 1500,
                                    disableOnInteraction: false,
                                }}
                                pagination={{
                                    dynamicBullets: true,
                                }}
                                modules={[Autoplay, EffectCoverflow, Pagination]}
                                className="mySwiper"
                            >
                                <SwiperSlide className='rounded-4'>
                                    <Card className="text-center rounded-4">
                                        <Card.Body>
                                            <h5>Dashboard</h5>
                                            <Card.Text>
                                                Displaying key sales, inventory, and customer analytics through metrics, charts, and graphs.
                                            </Card.Text>
                                            <Card.Img src={dashboard_img} alt="dashboard" className='img-fluid mt-3 mb-3' />
                                        </Card.Body>
                                    </Card>
                                </SwiperSlide>
                                <SwiperSlide className='rounded-4'>
                                    <Card className="text-center rounded-4">
                                        <Card.Body>
                                            <h5>Planning</h5>
                                            <Card.Text>
                                                Displaying customer delivery details and a mapped route in Central London.
                                            </Card.Text>
                                            <Card.Img src={planning_img} alt="planning" className='img-fluid mt-3 mb-3' />
                                        </Card.Body>
                                    </Card>
                                </SwiperSlide>
                                <SwiperSlide className='rounded-4'>
                                    <Card className="text-center rounded-4">
                                        <Card.Body>
                                            <h5>Sales Order</h5>
                                            <Card.Text>
                                                Listing customer orders with booking dates, delivery dates, statuses, and total values.
                                            </Card.Text>
                                            <Card.Img src={sales_order_img} alt="sales_order" className='img-fluid mt-3 mb-3' />
                                        </Card.Body>
                                    </Card>
                                </SwiperSlide>
                                <SwiperSlide className='rounded-4'>
                                    <Card className="text-center rounded-4">
                                        <Card.Body>
                                            <h5>Delivery Planning</h5>
                                            <Card.Text>
                                                Listing Customers on the left and a Google Maps route visualization on the right, showing a delivery path across Saudi Arabia.
                                            </Card.Text>
                                            <Card.Img src={delivery_planning_img} alt="delivery_planning" className='img-fluid mt-3 mb-3' />
                                        </Card.Body>
                                    </Card>
                                </SwiperSlide>
                                <SwiperSlide className='rounded-4'>
                                    <Card className="text-center rounded-4">
                                        <Card.Body>
                                            <h5>Customer</h5>
                                            <Card.Text>
                                                Showing customer information, sales performance, order status, and achievement progress across different slabs.
                                            </Card.Text>
                                            <Card.Img src={customer_details_img} alt="customer_details" className='img-fluid mt-3 mb-3' />
                                        </Card.Body>
                                    </Card>
                                </SwiperSlide>
                            </Swiper>
                        </div>

                        <div className="pt-4 pb-4 ps-5 pe-5">
                            <div className="d-sm-none d-lg-flex align-items-center justify-content-between">
                                <div>
                                    <div>
                                        <FaStar size={18} className='text-success me-1' />
                                        <FaStar size={18} className='text-success me-1' />
                                        <FaStar size={18} className='text-success me-1' />
                                        <FaStar size={18} className='text-success me-1' />
                                        <FaStar size={18} className='text-success me-1' />
                                    </div>
                                    <div className='text-white'>
                                        Loved by 1,000,000+ users
                                    </div>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <LuCopyright size={18} className='mb-2 me-1 text-white' />
                                    <h6 className='text-danger'>Techlene Associate</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {!toggle ?
                    <div className="col-sm-12 col-lg-5" data-aos="fade-left" data-aos-duration="1000">
                        <UserLoginForm setTogggle={setTogggle} />
                    </div>
                    : ''
                }

                {toggle ?
                    <div className="col-sm-12 col-lg-5 position-relative" data-aos="fade-left" data-aos-duration="1000">
                        <ForgetPasswordForm setTogggle={setTogggle} />
                    </div>
                    : ''
                }
            </div>
        </>
    )
}